import { Button, Flex, Popconfirm } from "antd";

import { useSW } from "@/hooks/app/useSW";
import { useOfflineModeSelector } from "@/hooks/redux";
import { PrimaryText } from "@/shared/ui/Typography";

import { StyledInfoCircleOutlined, StyledUpdateBanner } from "./Styled";

const storeResetWarning =
    "Після оновлення поточний прогрес у додатку буде скинуто.";

export const UpdateBanner = () => {
    const { needRefresh, applyUpdate, storeReset } = useSW();
    const offlineMode = useOfflineModeSelector();

    if (!needRefresh) return null;

    return (
        <StyledUpdateBanner>
            <Flex gap={16} justify="space-between">
                <Flex gap={16} align="center">
                    <StyledInfoCircleOutlined />

                    <PrimaryText>Доступне оновлення додатку</PrimaryText>
                </Flex>

                <Popconfirm
                    title={
                        <Flex vertical gap={4}>
                            <PrimaryText lineHeight="22px">
                                Ви впевнені що готові оновити застосунок?
                            </PrimaryText>

                            {needRefresh && storeReset && (
                                <PrimaryText textColor="error">
                                    {storeResetWarning}
                                </PrimaryText>
                            )}
                        </Flex>
                    }
                    onConfirm={applyUpdate}
                    okText="Так"
                    cancelText="Ні"
                >
                    <Button type="primary" disabled={offlineMode}>
                        Оновити
                    </Button>
                </Popconfirm>
            </Flex>

            {needRefresh && storeReset && (
                <PrimaryText textColor="error" fontSize={16} fontWeight="500">
                    {storeResetWarning}
                </PrimaryText>
            )}
        </StyledUpdateBanner>
    );
};
